import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language/language.service';

@Pipe({
    name: 'translate',
    standalone: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}
  transform(key: string, params?: any): string {
    let translation = this.languageService.translate(key);
    if (!translation) return '';
    if (params) {
      Object.keys(params).forEach(param => {
        translation = translation.replace(`{{${param}}}`, params[param]);
      });
    }
    return translation;
  }
}
